<div class="header">
    <div class="header-top">
        <div class="content-container-top ">
            <div class="pure-u-12-24">
                This site is intended for US Healthcare Professionals only.
            </div>
            <div class="pure-u-12-24 healthcareanchor">
                <a routerLink="/patient">Visit Patient Site<img src="../../../assets/img/hcp_arow_icon.svg"/></a>
            </div>
        </div>
     </div>
</div>